import { useTranslation } from "react-i18next";

export type AnalyticsView = "workers" | "products" | "operations" | "activities";

export interface AnalyticsTabsProps {
  active: AnalyticsView;
  onChange: (view: AnalyticsView) => void;
}

const VIEWS: AnalyticsView[] = ["workers", "products", "operations", "activities"];

/** Same accessible tab pattern as MasterDataPage's tab strip (role="tablist"/"tab", aria-selected) — no new tab implementation invented. */
export function AnalyticsTabs({ active, onChange }: AnalyticsTabsProps) {
  const { t } = useTranslation("analytics");

  return (
    <div className="nx-analytics__tabs" role="tablist">
      {VIEWS.map((view) => (
        <button
          key={view}
          type="button"
          role="tab"
          id={`analytics-tab-${view}`}
          aria-selected={active === view}
          aria-controls={`analytics-panel-${view}`}
          className={["nx-analytics__tab", active === view ? "nx-analytics__tab--active" : ""].filter(Boolean).join(" ")}
          onClick={() => onChange(view)}
        >
          {t(`tabs.${view}`)}
        </button>
      ))}
    </div>
  );
}
